import React from 'react';
import { StatTile } from './ui/StatTile';
import { fmtMinor } from '../lib/money';
import { useStripeMrr } from '../hooks/useStripeMrr';

/** GBP and USD MRR side by side, from Stripe’s own prices. Never converted. */
export const MrrTiles: React.FC = () => {
  const q = useStripeMrr();
  const gbp = q.data?.mrr.byCurrency.gbp;
  const usd = q.data?.mrr.byCurrency.usd;
  const truncated = q.data?.mrr.possiblyTruncated;
  const note = q.error
    ? 'Stripe read failed'
    : truncated ? `Stripe read stopped at ${q.data?.mrr.returned} subscriptions; older ones may be missing`
    : undefined;
  return (
    <>
      <StatTile
        label="MRR in pounds"
        value={q.isLoading ? 'Loading' : gbp ? fmtMinor(gbp.mrrMinor, 'gbp') : fmtMinor(0, 'gbp')}
        sub={gbp ? `${gbp.subs} subscription${gbp.subs === 1 ? '' : 's'}: ${gbp.monthly} monthly, ${gbp.yearly} yearly` : note ?? 'No GBP subscriptions'}
        source={`Stripe, active and trialing; past due left out; yearly divided by 12${truncated ? '. Possibly incomplete' : ''}`}
        tone={q.error || truncated ? 'warn' : 'default'}
      />
      <StatTile
        label="MRR in dollars"
        value={q.isLoading ? 'Loading' : usd ? fmtMinor(usd.mrrMinor, 'usd') : fmtMinor(0, 'usd')}
        sub={usd ? `${usd.subs} subscription${usd.subs === 1 ? '' : 's'}: ${usd.monthly} monthly, ${usd.yearly} yearly` : note ?? 'No USD subscriptions'}
        source="Stripe, active and trialing; never converted to pounds"
        tone={q.error || truncated ? 'warn' : 'default'}
      />
    </>
  );
};
